/** Blender exports share the existing atlas, rig pivots, and moving boss-part contracts. */
import { Mesh, VertexData } from '@babylonjs/core/pure';
import type { PBRMaterial, Scene } from '@babylonjs/core/pure';
import type { CharacterGeometry } from './actors';
import type { AtlasTile } from './soldierAtlas';
import soldier from './assets/soldier.json';
import brute from './assets/brute.json';
import tankHull from './assets/tank-boss-torso.json';
import tankTurret from './assets/tank-boss-turret.json';
import tankBarrel from './assets/tank-boss-barrel.json';
import heliBody from './assets/heli-boss-torso.json';
import heliRotor from './assets/heli-boss-rotor.json';
import heliTailRotor from './assets/heli-boss-tail-rotor.json';

const assets = { soldier, brute, tankHull, tankTurret, tankBarrel, heliBody, heliRotor, heliTailRotor };
export type AuthoredActor = keyof typeof assets;

export function authoredGeometry(id: AuthoredActor, scene: Scene, material: PBRMaterial, name: string): CharacterGeometry {
  const asset = assets[id];
  const mesh = new Mesh(name, scene);
  const data = new VertexData();
  data.positions = asset.positions;
  data.normals = asset.normals;
  data.uvs = asset.uvs;
  if (asset.colors.some((value) => value !== 1)) data.colors = asset.colors;
  data.indices = asset.indices;
  data.applyToMesh(mesh);
  mesh.material = material;
  return { mesh, parts: asset.parts.map((part) => ({ ...part, tile: part.tile as AtlasTile })) };
}
